export default __webpack_public_path__ + "static/media/facebook.ec02310b.svg";